const getNow = () => new Date().getTime();

export class TimedCache<K, V> {
  private expiresMs: number;
  private defaultValue: V;
  private cache: Map<K, { value: V; expiresAt: number }> = new Map();

  constructor(defaultValue: V, expirySeconds: number = 300) {
    this.defaultValue = defaultValue;
    this.expiresMs = expirySeconds * 1000;
  }

  set(key: K, value: V) {
    this.cache.set(key, { value, expiresAt: getNow() + this.expiresMs });
  }

  get(key: K): V | null {
    const cacheContent = this.cache.get(key);

    if (!cacheContent) {
      return this.defaultValue;
    }

    if (cacheContent.expiresAt <= getNow()) {
      this.cache.delete(key);
      return this.defaultValue;
    }

    return cacheContent.value;
  }

  keys(): K[] {
    return Array.from(this.cache.keys());
  }

  has(key: K) {
    return this.cache.has(key);
  }

  clear() {
    this.cache.clear();
  }
}
